import { Organization } from "../organization.model.ts";
import { BaseSerializer } from "./baseSerializer.ts";

export class OrganizationSerializer extends BaseSerializer {

    public deserialize( data: any ): any {
        const organization = new Organization();
        this._copyAttributes(organization, data);
        if (data?.parent != null && organization.parent_id == null) {
            organization.parent_id = data.parent;
        }
        return organization;

    }

}
